import {NgModule} from '@angular/core';
import {RouterModule, Routes} from '@angular/router';
import {AktivitetListComponent} from './aktiviteter.component';
import {AktivitetDetailComponent} from './aktivitet.component';
import {BroderkortComponent} from './broderkort.component';
import {AuthGuard} from './auth.guard';
import {LoginComponent} from './login.component';
import {ConsminlistaImportComponent} from './consminlista-import.component';

const routes: Routes = [
    {path: '', redirectTo: '/tilldelning', pathMatch: 'full'},
    {path: 'login', component: LoginComponent},
    {path: 'tilldelning', component: AktivitetListComponent, canActivate: [AuthGuard]},
    {path: 'consmin-import', component: ConsminlistaImportComponent, canActivate: [AuthGuard]},
    {path: 'tilldelning/:aktiviteter_id', component: AktivitetDetailComponent, canActivate: [AuthGuard]},
    {path: 'tilldelning/:aktiviteter_id/:broder_id', component: BroderkortComponent, canActivate: [AuthGuard]}
];

@NgModule({
    imports: [RouterModule.forRoot(routes)],
    exports: [RouterModule]
})
export class AppRoutingModule {
}



// WEBPACK FOOTER //
// /builds/johannes-jonsson/consmin-app/src/app/app-routing.module.ts